import AListGroupHeader from './index.vue';

AListGroupHeader.install = app => {
  app.component(AListGroupHeader.name, AListGroupHeader);
};

export default AListGroupHeader;
